// extracted by mini-css-extract-plugin
export default {"overallContainer":"styles_overallContainer__JHzLW","overallText":"styles_overallText__04kmz","dark":"styles_dark__5kyU0"};